module.exports = __webpack_public_path__ + "img/2023-11_research.ebc7e096.jpg";